import { render, staticRenderFns } from "./AnnouncementDetailDialog.vue?vue&type=template&id=3e818f3c&scoped=true&"
import script from "./AnnouncementDetailDialog.vue?vue&type=script&lang=js&"
export * from "./AnnouncementDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementDetailDialog.vue?vue&type=style&index=0&id=3e818f3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e818f3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VChip,VDialog,VDivider})
